import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-author">Pablo Chaves Maza</p>
        {/* <p className="footer-phone">
          Tel: <a href="tel:+34655932364">655 932 364</a>
        </p> */}
        {/* <p className="footer-email">
          Email:{" "}
          <a href="mailto:pablochavesmaza@hotmail.com">
            pablochavesmaza@hotmail.com
          </a>
        </p> */}
      </div>
    </footer>
  );
}

export default Footer;
